<dialog-frame header="Confirm" [actions]="actions()" icon="fa-question-circle" (closed)="activeModal.close($event)">

	<div class="py-2">
		<p class="text-center">{{ data().message }}</p>

		@if(data().bullets?.length) {
		<div class="m-1">
			<ul>
				@for(bullet of data().bullets; track bullet){
				<li>{{ bullet }}</li>
				}
			</ul>
		</div>
		}
	</div>

</dialog-frame>